import DEFULAT_USER_PHOTO from '../assets/images/default.png'
import { BASE_URL } from '../constants/constants'
const useCanstants = () => {
  return {BASE_URL, DEFULAT_USER_PHOTO}
}

export default useCanstants;